export default "__VITE_ASSET__Bv2bqy4L__"